<template>
  <h1 class="db-title">👋 {{ message }}, {{ name }}!</h1>
</template>
<script>
export default {
  props: ["message", "name"]
};
</script>
